import { jsx as i } from "react/jsx-runtime";
import { TextProvider as u } from "../../../context/Text.js";
import "styled-components";
import { useThemeInMode as g } from "../../../context/theme/hooks.js";
import { DISABLED_OPACITY as s } from "../../../styles/colors/consts.js";
import { typographyBodySizeMap as h, typographyBodyLineHeightMap as f } from "../../../styles/typography/typography.js";
import "../../layout/Stack/Stack.js";
import b from "../../layout/Box/Box.js";
import "react";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import { uppercaseStyles as x } from "../consts.js";
function P({
  children: o,
  tone: e,
  strength: r,
  size: t,
  uppercase: m,
  dataNoTranslate: l,
  disabled: a = !1,
  borderRadius: n = "xxlarge"
}) {
  const { backgroundColor: p, color: d, borderColor: c } = C(e, r);
  return /* @__PURE__ */ i(u, { value: !0, children: /* @__PURE__ */ i(
    b,
    {
      paddingX: "12",
      paddingY: "small",
      width: "max-content",
      height: "max-content",
      fontWeight: "bold",
      ...h[t],
      ...f.large,
      opacity: a ? s : "1",
      backgroundColor: p,
      color: d,
      borderColor: c,
      borderStyle: r === "weakWithOutline" ? "solid" : "none",
      borderRadius: n,
      borderWidth: "xxxsmall",
      ...m && x,
      dataNoTranslate: l,
      children: o
    }
  ) });
}
function C(o, e) {
  const r = g();
  let t;
  return t = {
    backgroundColor: e === "strong" ? `${o}-high-surface` : `${o}-medium-surface`,
    color: e === "strong" ? `contentOn-${o}-high-surface` : `${o}-high-content`,
    borderColor: `${o}-medium-content`
  }, {
    backgroundColor: r[t.backgroundColor],
    color: r[t.color],
    borderColor: r[t.borderColor]
  };
}
export {
  P as default
};
